import { selectEnv } from '../env';

export const logoColor = selectEnv('#02c874', '#1176D4', '#e84f4f');
